import { TransformTable } from "../../../../../src/demos/transform-table";
import * as React from 'react';
export default {
  TransformTable,
  React
};